export const styles = theme => ({
    contentFull: {
        height: '100%',
        width: '100%',
        overflow: 'scroll'
    }
});